import { RootGetterTypes } from './types';

export const getters = {
    [RootGetterTypes.GetHost](state) {
        return state.host
    },
    [RootGetterTypes.GetSettings](state) {
        return state.settings
    },
    [RootGetterTypes.GetOrigin](state) {
        return state.origin
    },
}
